import React, { ReactNode } from 'react'
import { StyleProp, View, ViewStyle } from 'react-native'
import styled from 'styled-components/native'
import ReactModal from 'react-modal'
import { Flex } from '../FlexBox'
import DismissIcon from '../icon/DismissIcon'
import TouchableOpacity from './GestureTouchableOpacity'

ReactModal.setAppElement('#root')

const ModalBodyContainer = styled(View)`
  min-width: 300px;
  border-radius: 10px;
  padding: 10px;
  background-color: #ffffff;
`

const defaultOverlayStyle = {
  backgroundColor: 'rgba(0, 0, 0, 0.5)',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center'
}

const defaultContentStyle = {
  position: 'static'
}

const Modal = ({
  children,
  open,
  close,
  overlayStyle,
  contentStyle,
  bodyStyle,
  showCloseIcon
}: ModalProps) => {
  return (
    <ReactModal
      isOpen={open}
      onRequestClose={close}
      style={{
        overlay: overlayStyle ?? defaultOverlayStyle,
        content: contentStyle ?? defaultContentStyle
      }}
    >
      {showCloseIcon && (
        <Flex flexDirection="row" justifyContent="end">
          <TouchableOpacity onPress={close}>
            <DismissIcon size={18} />
          </TouchableOpacity>
        </Flex>
      )}
      {/* bodyStyle lets a caller override the default centred card -- a
          full-height side panel needs this to stretch rather than size to its
          content. */}
      <ModalBodyContainer style={bodyStyle}>{children}</ModalBodyContainer>
    </ReactModal>
  )
}

interface ModalProps {
  children: ReactNode
  close: () => void
  open: boolean
  /**
   * Handed straight to react-modal, so these are DOM CSS objects rather than
   * React Native styles -- they accept properties like inset, border and
   * background that ViewStyle has no notion of.
   */
  overlayStyle?: Record<string, any>
  contentStyle?: Record<string, any>
  /** Applied to the inner View, so this one really is a ViewStyle. */
  bodyStyle?: StyleProp<ViewStyle>
  showCloseIcon?: boolean
}

export default Modal
